module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Koblenz_AG-01c2cdb1f5ab3ebcff1a9c795005c60c.svg";